module.exports = __webpack_public_path__ + "img/l5.05370e84.png";